module.exports = __webpack_public_path__ + "static/media/icon-vertical-bat.aed397e3.svg";